import { defineMessages } from 'react-intl-next';

export const messages: {
    cross_product_tab_label: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    cross_product_expanded_input_placeholder: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    cross_product_recents_section_heading: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    cross_product_results_section_heading: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    googleDocsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    googleSlidesLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    googleSheetsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    msWordLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    msPowerpointLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    msExcelLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    cross_product_empty_state_body: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    documentLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    spreadsheetLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    presentationLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    fileLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    databaseLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    webPageLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    pageLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    blogpostLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    dashboardLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    invoiceLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    designLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    dealLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    videoLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    taskLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    issueLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    spaceLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    projectLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    repositoryLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    customerOrgLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    imageLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    archiveLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    audioLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    pdfLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    codeLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    otherLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	cross_product_tab_label: {
		id: 'product_search_dialog.cross_product.tab_label',
		defaultMessage: 'All',
		description: 'Label to display for the Cross Product search tab',
	},
	cross_product_expanded_input_placeholder: {
		id: 'product_search_dialog.cross_product.expanded.input-placeholder',
		defaultMessage: 'Search All',
		description: 'The placeholder which is visible to the user when Cross Product tab is active ',
	},
	cross_product_recents_section_heading: {
		id: 'product_search_dialog.cross_product.recents.section_heading',
		defaultMessage: 'Recently viewed',
		description: 'The heading to display for the Cross Product recents section',
	},
	cross_product_results_section_heading: {
		id: 'product_search_dialog.cross_product.results.section_heading',
		defaultMessage: 'Search results',
		description: 'The heading to display for the Cross Product results section',
	},
	googleDocsLabel: {
		id: 'document-search-result.google-docs-label',
		defaultMessage: 'Docs',
		description: 'Google Docs subtype label',
	},
	googleSlidesLabel: {
		id: 'document-search-result.google-slides-label',
		defaultMessage: 'Slides',
		description: 'Google Slides subtype label',
	},
	googleSheetsLabel: {
		id: 'document-search-result.google-sheets-label',
		defaultMessage: 'Sheets',
		description: 'Google Sheets subtype label',
	},
	msWordLabel: {
		id: 'document-search-result.ms-word-label',
		defaultMessage: 'Word',
		description: 'Microsoft Word subtype label',
	},
	msPowerpointLabel: {
		id: 'document-search-result.ms-powerpoint-label',
		defaultMessage: 'PowerPoint',
		description: 'Microsoft PowerPoint subtype label',
	},
	msExcelLabel: {
		id: 'document-search-result.ms-excel-label',
		defaultMessage: 'Excel',
		description: 'Microsoft Excel subtype label',
	},
	cross_product_empty_state_body: {
		id: 'product_search_dialog.cross_product.empty.no_results_body',
		defaultMessage: '<a>Search all content across your organization</a> or try a different term.',
		description: '',
	},

	documentLabel: {
		id: 'document.label',
		defaultMessage: 'Document',
		description: 'Document subtype label',
	},
	spreadsheetLabel: {
		id: 'spreadsheet.label',
		defaultMessage: 'Spreadsheet',
		description: 'Spreadsheet subtype label',
	},
	presentationLabel: {
		id: 'presentation.label',
		defaultMessage: 'Presentation',
		description: 'Presentation subtype label',
	},
	fileLabel: {
		id: 'file.label',
		defaultMessage: 'File',
		description: 'File subtype label',
	},
	databaseLabel: {
		id: 'database.label',
		defaultMessage: 'Database',
		description: 'Database subtype label',
	},
	webPageLabel: {
		id: 'web-page.label',
		defaultMessage: 'Web Page',
		description: 'Web Page subtype label',
	},
	pageLabel: {
		id: 'page.label',
		defaultMessage: 'Page',
		description: 'Page subtype label',
	},
	blogpostLabel: {
		id: 'blogpost.label',
		defaultMessage: 'Blogpost',
		description: 'Blogpost subtype label',
	},
	dashboardLabel: {
		id: 'dashboard.label',
		defaultMessage: 'Dashboard',
		description: 'Dashboard subtype label',
	},
	invoiceLabel: {
		id: 'invoice.label',
		defaultMessage: 'Invoice',
		description: 'Invoice subtype label',
	},
	designLabel: {
		id: 'design.label',
		defaultMessage: 'Design',
		description: 'Design subtype label',
	},
	dealLabel: {
		id: 'deal.label',
		defaultMessage: 'Deal',
		description: 'Deal subtype label',
	},
	videoLabel: {
		id: 'video.label',
		defaultMessage: 'Video',
		description: 'Video subtype label',
	},
	taskLabel: {
		id: 'task.label',
		defaultMessage: 'Task',
		description: 'Task subtype label',
	},
	issueLabel: {
		id: 'issue.label',
		defaultMessage: 'Work item',
		description: 'Issue subtype label',
	},
	spaceLabel: {
		id: 'space.label',
		defaultMessage: 'Space',
		description: 'Space subtype label',
	},
	projectLabel: {
		id: 'project.label',
		defaultMessage: 'Project',
		description: 'Project subtype label',
	},
	repositoryLabel: {
		id: 'repository.label',
		defaultMessage: 'Repository',
		description: 'Repository subtype label',
	},
	customerOrgLabel: {
		id: 'customer-org.label',
		defaultMessage: 'Customer Org',
		description: 'Customer Org subtype label',
	},
	imageLabel: {
		id: 'image.label',
		defaultMessage: 'Image',
		description: 'Image subtype label',
	},
	archiveLabel: {
		id: 'archive.label',
		defaultMessage: 'Archive',
		description: 'Archive subtype label',
	},
	audioLabel: {
		id: 'audio.label',
		defaultMessage: 'Audio',
		description: 'Audio subtype label',
	},
	pdfLabel: {
		id: 'pdf.label',
		defaultMessage: 'PDF',
		description: 'PDF subtype label',
	},
	codeLabel: {
		id: 'code.label',
		defaultMessage: 'Code',
		description: 'Code subtype label',
	},
	otherLabel: {
		id: 'other.label',
		defaultMessage: 'Other',
		description: 'Other subtype label',
	},
});
